<template>
  <div class="page">
    <box>
      <el-form label-position="right" label-width="100px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="通道编号" class="EL-Form-Item">
            <el-select
              v-model="mainSearch.whCode"
              placeholder="请选择"
              filterable
              clearable="clearable"
              @change="getTableData"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.whId"
                :label="item.whCode + '-' + item.whName"
                :value="item.whCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.matCode"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="操作编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.pmCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col> -->
        <!-- <el-col :lg="5" :xl="5">
          <el-form-item label="生产工单" class="EL-Form-Item">
            <el-input v-model="mainSearch.opCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :lg="5" :xl="5">
          <el-form-item label="送货状态" class="EL-Form-Item">
            <el-select v-model="mainSearch.distrType">
              <el-option label="默认(待装车、已装车)" value="10,20" />
              <el-option label="待装车" value="10" />
              <el-option label="已装车" value="20" />
              <el-option label="已完成" value="30" />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- <el-col :lg="5" :xl="5">
          <el-form-item label="配送方式" class="EL-Form-Item">
            <el-select v-model="mainSearch.distrWay" clearable>
              <el-option label="AGV配送" value="10" />
              <el-option label="人工配送" value="20" />
            </el-select>
          </el-form-item>
        </el-col> -->

        <el-col :lg="5" :xl="5">
          <el-form-item label="箱号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.boxBarCode"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="装车单号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.ppCode"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :lg="9" :xl="9">
                    <el-form-item label="日期范围" class="EL-Form-Item">
                        <el-date-picker style="width: 350px" v-model="mainSearch.date" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
        <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker
              v-model="mainSearch.date[0]"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="开始日期"
              :picker-options="pickerOptions0"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker
              v-model="mainSearch.date[1]"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="saveSearch()">查询</el-button>
            <el-button class="btn-t-delete" @click="resetMain">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </box>
    <box fill>
      <plabel text="物料装车">
        <el-button
          v-authority="'BACK_MENU3_M26_B1'"
          class="btn-t-edit"
          @click="peopleDistribution()"
        >
          装车
        </el-button>
        <el-button
          v-authority="'BACK_MENU3_M26_B1'"
          class="btn-t-edit"
          @click="openDialog"
        >
          合并装车
        </el-button>
        <!--  <el-button v-authority="'BACK_MENU3_M4_B2'" class="btn-t-edit" @click="personPickComplete()">
         装车
       </el-button>
      <el-button v-authority="'BACK_MENU3_M4_B3'" class="btn-t-edit" @click="openDialog()">
         AGV配送
       </el-button> -->
        <el-button class="btn-t-edit" type="primary" @click="doPrint()"
          >打印</el-button
        >
        <el-button
          v-authority="'BACK_MENU3_M4_B4'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >
      </plabel>
      <h-table
        :headerCellStyle="mainData.headerCellStyle"
        style="flex: 1"
        @pageChange="getTableData"
        :data="mainData.data"
        pagination
        :nowPage.sync="mainData.nowPage"
        :pageSize.sync="mainData.pageSize"
        :total.sync="mainData.total"
        @selectionChange="selectAllMain"
      >
        <el-table-column
          type="selection"
          align="center"
          :selectable="checkboxMain"
        >
        </el-table-column>
        <el-table-column label="装车单号" align="center" prop="ppCode">
        </el-table-column>
        <el-table-column label="通道编号" align="center" prop="whCode">
          <template slot-scope="scope">
            {{ scope.row.whCode }}
            <span v-if="scope.row.whCode != scope.row.whCodeP"
              >(叫料通道:{{ scope.row.whCodeP }})</span
            >
          </template>
        </el-table-column>
        <el-table-column label="物料编号" align="center" prop="matCode">
        </el-table-column>
        <el-table-column label="物料描述" align="center" prop="matName">
        </el-table-column>
        <el-table-column label="物料数量" align="center" prop="matQuan">
        </el-table-column>
        <el-table-column label="实际库位" align="center" prop="lcCodeReal">
          <template slot-scope="scope">
            <span>{{ scope.row.lcCodeReal }}</span>
          </template>
        </el-table-column>
        <el-table-column label="包装箱号" align="center" prop="boxBarcode">
        </el-table-column>
        <!-- <el-table-column label="操作编号" align="center" prop="operaCode"> </el-table-column>
        <el-table-column label="生产工单" align="center" prop="opCode"> </el-table-column> -->
        <!-- <el-table-column label="需求类型" align="center" prop="operaType">
          <template slot-scope="scope">
            <span v-if="scope.row.operaType == '10'">生产叫料</span>
            <span v-if="scope.row.operaType == '20'">间材叫料</span>
            <span v-if="scope.row.operaType == '30'">采购退货</span>
            <span v-if="scope.row.operaType == '40'">移库</span>
          </template>
        </el-table-column> -->
        <el-table-column label="状态" align="center" prop="distrType">
          <template slot-scope="scope">
            <span v-if="scope.row.distrType == '10'">待装车</span>
            <span v-if="scope.row.distrType == '20'">已装车</span>
            <span v-if="scope.row.distrType == '30'">已完成</span>
            <!-- <span v-if="!scope.row.distrType">待检配</span> -->
          </template>
        </el-table-column>
        <!-- <el-table-column label="配送人" align="center" prop="userName"> </el-table-column> -->

        <!-- <el-table-column label="配送方式" align="center" prop="distrWay">
          <template slot-scope="scope">
            <div v-if="scope.row.distrWay == '10'">AGV配送</div>
            <div v-if="scope.row.distrWay == '20'">人工配送</div>
          </template>
        </el-table-column> -->

        <el-table-column label="装车时间" align="center" prop="createTime">
        </el-table-column>
        <el-table-column label="更新时间" align="center" prop="updateTime">
        </el-table-column>
      </h-table>
    </box>
    <el-dialog
      title="AGV配送"
      :visible.sync="dialogShow"
      class="fromDialog"
      :close-on-click-modal="false"
      :show-close="false"
      :style="$popups.popups(0.8, 0.9)"
    >
      <div style="overflow: hidden; padding-bottom: 10px">
        <el-form label-position="right" label-width="80px">
          <el-col :lg="5" :xl="5">
            <!-- <el-form-item label="库位">
                            <el-input v-model="agvInfo.laCode" placeholder="请输入"></el-input>
                        </el-form-item> -->
            <el-form-item label="单号" class="EL-Form-Item">
              <el-select v-model="ppCode" placeholder="请选择" filterable>
                <el-option
                  v-for="(item, index) in ppCodeList"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <h-table
        :style="$popups.harvestRecordStyle(0.63, 0.02)"
        :headerCellStyle="mainData.headerCellStyle"
        :data="checkListMain"
      >
        <el-table-column label="装车单号" align="center" prop="ppCode">
        </el-table-column>
        <el-table-column label="包箱编号" align="center" prop="boxBarcode">
        </el-table-column>
        <el-table-column label="物料编号" align="center" prop="matCode">
        </el-table-column>
        <el-table-column label="物料描述" align="center" prop="matName">
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime">
        </el-table-column>
        <el-table-column label="更新时间" align="center" prop="updateTime">
        </el-table-column>
      </h-table>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="closeDailog" type="info" class="btn-t-info"
          >关 闭</el-button
        >
        <el-button
          :loading="agvDistributions"
          @click="agvDistribution"
          class="btn-t-edit"
          >确 认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="人工配送完成"
      :visible.sync="personDistrShow"
      class="minInfoDialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div style="overflow: hidden; padding-bottom: 10px">
        <el-form label-position="right" label-width="80px">
          <el-form-item label="库位编号" prop="lcCode" class="EL-Form-Item">
            <el-select
              v-model="lcCode"
              clearable="clearable"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in sysLineRouterList"
                :key="index"
                :value="item.lrRealCode"
                :label="item.lrRealCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="personDistrClose()" type="info" class="btn-t-info"
          >关 闭</el-button
        >
        <el-button @click="personPickComplete()" class="btn-t-edit"
          >确 认</el-button
        >
      </div>
    </el-dialog>

    <!-- 打印 -->
    <el-dialog
      :visible.sync="printShow"
      width="1200px"
      :close-on-click-modal="false"
    >
      <v-print :doPrint.sync="print">
        <div id="demo" class="demo">
          <div style="position: relative;">
            <div
              style="
                            font-size: 30px;
                            font-weight: 600;
                            margin-top: 40px;
                            margin-bottom: 40px;
                            text-align: center;
                            "
            >
              外仓送货单
            </div>
            <div style="margin-bottom: 10px;font-size: 20px;text-align: left">
              <span style="margin-right: 50px">日期: {{ timeDate }}</span>
              <span style="margin-right: 50px"
                >送货单号: {{ printPPCode }}</span
              >
              <span style="margin-right: 50px"
                >总箱数: {{ printList.length }}</span
              >
            </div>
            <qr-code
              id="printPPCode"
              :value="printPPCode"
              text="送货单"
              width="100"
              height="100"
              style="position: absolute;right: 10px;top: 10px;"
            ></qr-code>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <thead>
                  <tr>
                    <th>物料编号</th>
                    <th>物料名称</th>
                    <th>批次号</th>
                    <th>数量</th>
                    <th>箱号</th>
                    <th>运输托盘类型</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, rowIdx) in printList" :key="rowIdx">
                    <td>{{ row.matCode }}</td>
                    <td>{{ row.matName }}</td>
                    <td>{{ row.batchNo }}</td>
                    <td>{{ row.matQuan }}</td>
                    <td>{{ row.boxBarcode }}</td>
                    <td>{{ row.palletCode }}</td>
                  </tr>

                  <tr v-for="n in 2" :key="n + 'a'">
                    <td v-for="i in 6" :key="i" style="height: 22px;"></td>
                  </tr>
                  <tr>
                    <td style="height: 22px;">外仓司机签字</td>
                    <td style="height: 22px;"></td>
                    <td style="height: 22px;">内仓发货人签字</td>
                    <td style="height: 22px;"></td>
                    <td style="height: 22px;"></td>
                    <td style="height: 22px;"></td>
                  </tr>
                  <tr>
                    <td
                      v-for="i in 6"
                      :key="i + 'b'"
                      style="height: 22px;"
                    ></td>
                  </tr>
                  <tr>
                    <td style="height: 22px;">日期</td>
                    <td style="height: 22px;"></td>
                    <td style="height: 22px;">日期</td>
                    <td style="height: 22px;"></td>
                    <td style="height: 22px;"></td>
                    <td style="height: 22px;"></td>
                  </tr>
                  <tr>
                    <td
                      v-for="i in 6"
                      :key="i + 'c'"
                      style="height: 22px;"
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </v-print>
      <div style="margin-top: 50px;height:80px">
        <el-button
          class="btn-t-info"
          type="info"
          @click="(printShow = false), (printList = [])"
          >取消</el-button
        >
        <el-button
          class="btn-t-edit"
          @click="(print = true), (printShow = false)"
          >打印</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vPrint from "syl-vue-printer";
export default {
  name: "OuterWarehouseLoading",
  components: {
    vPrint
  },
  data() {
    return {
      mainData: {
        data: [],
        nowPage: 1,
        pageSize: 50,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        }
      },
      // 筛选条件
      mainSearch: {
        fcCode: localStorage.getItem("fcCode") || "",
        person: localStorage.getItem("user"),
        whCode: localStorage.getItem("whCode") || "", //通道编号
        // pmCode: '', //	生产叫料编号
        ppCode: "", //	生产工单编号
        matCode: "", //	物料编号
        distrType: "10,20",
        // distrWay: '',
        boxBarCode: "",
        date: []
      },
      whCodeId: "",
      warehouseList: [],
      //多选
      checkListMain: [],
      ppCodeList: [],
      ppCode: "",
      //配送单
      agvInfo: {
        pmIds: "",
        laCode: "", //库位
        whCode: "" //通道
      },
      dialogShow: false,

      downloadLoading: false, //下载中
      agvDistributions: false,

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注

      //agv搬运产线点位
      sysLineRouterList: [],
      //agv搬运备料区点位
      sysPointRouterList: [],

      personDistrShow: false, //人工配送完成
      lcCode: "", //产线库位
      // 输入框延时加载
      isSetTimeout: null,

      // 打印相关
      timeDate: "",
      print: false,
      printShow: false,
      printPPCode: "",
      printList: []
    };
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[0]) {
            return time.getTime() < new Date(_this.mainSearch.date[0]);
          }
        }
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[1]) {
            return time.getTime() > new Date(_this.mainSearch.date[1]);
          }
        }
      };
    }
  },
  watch: {
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.mainData.nowPage = 1;
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true
    }
  },

  methods: {
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.mainData.nowPage = 1;
        this.getTableData();
      }, 1000);
    },
    /**
     * 打开人工搬运窗口
     */
    openPersonDistrShow() {
      if (this.checkListMain.length == 0) {
        this.$message({
          message: "请至少选择一个物料人工配送中的记录！",
          type: "warning"
        });
        return;
      } else {
        var whCode = this.checkListMain[0].whCode;
        var flag = false;
        var distrTypeFlag = false;
        this.checkListMain.forEach(item => {
          if (whCode !== item.whCode) {
            flag = true;
          }
          if (item.distrType !== "20") {
            distrTypeFlag = true;
          }
        });
        if (distrTypeFlag) {
          this.$message({
            message: "请选择人工配送中的内容进行人工确认完成操作",
            type: "warning"
          });
          return;
        }
        if (flag) {
          this.$message({
            message: "请选择通道相同的物料人工配送进行人工确认完成操作！",
            type: "warning"
          });
          return;
        } else {
          if (whCode == "54") {
            this.getLcCodeAllByWhCode("");
          } else {
            this.getLcCodeAllByWhCode(whCode);
          }
          this.personDistrShow = true;
        }
      }
    },
    getTableData() {
      this.$http
        .request({
          url: "/api/stockPickDetail/getStockPickDetailData",
          method: "GET",
          params: {
            pageNum: this.mainData.nowPage, //	页号
            pageSize: this.mainData.pageSize, //	页大小
            whCode: this.mainSearch.whCode,
            fcCode: this.mainSearch.fcCode,
            // person: this.mainSearch.person || null,
            distrType: this.mainSearch.distrType || null,
            distrWay: this.mainSearch.distrWay || null,
            operaCode: this.mainSearch.pmCode || null, //	生产叫料编号
            opCode: this.mainSearch.opCode || null, //	生产工单编号
            matCode: this.mainSearch.matCode || null, //	物料编号
            boxBarCode: this.mainSearch.boxBarCode || null, //箱号
            ppCode: this.mainSearch.ppCode,
            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null, //	开始时间
            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null, //	结束时间
            operaType: "70"
          }
        })
        .then(res => {
          if (res.status == 100) {
            this.mainData.data = res.data.list;
            this.mainData.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        });
    },

    //关闭弹框
    personDistrClose() {
      this.personDistrShow = false;
      this.lcCode = "";
    },

    /**
     * 通道列表
     */
    getWarehouse() {
      this.$http
        .request({
          url: "/api/warehouse/getWarehouse",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || "",
            whCode: ""
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.warehouseList = resp.data.list || [];
          }
        })
        .catch(error => {
          this.loading++;
        });
    },
    /**
     * 禁选
     */
    checkboxMain(row, rowIndex) {
      // if (row.distrType == "10") {
      //     return true; // 不禁用
      // } else {
      //     return false; // 禁用
      // }
      return true;
    },
    /**
     * 全选
     */
    selectAllMain(val) {
      this.checkListMain = val;
    },

    /**
     * 重置
     */
    resetMain() {
      this.mainSearch = {
        fcCode: localStorage.getItem("fcCode") || "",
        person: localStorage.getItem("user"),
        whCode: "", //通道编号
        pmCode: "", // 生产叫料编号
        opCode: "", // 生产工单编号
        matCode: "", // 物料编号
        distrType: "10,20",
        distrWay: "",
        date: []
      };
    },

    /**
     * 获取可用的备料区库位编号
     */
    getSysPointRouterMatSpare() {
      this.$http
        .request({
          url: "/api/sysPointRouter/getSysPointRouterMatSpare",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || ""
            //whCode: this.checkListMain[0].whCode || null,
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.sysPointRouterList = resp.data.list || [];
          }
        })
        .catch(error => {
          this.loading++;
        });
    },

    /**
     * 人工配送
     */
    peopleDistribution() {
      if (this.checkListMain.length == 0) {
        this.$message({
          message: "请选择生产叫料",
          type: "warning"
        });
        return;
      }
      const res = this.checkListMain.every(e => {
        if (e.operaType == "30") {
          this.$message({
            message: "采购退货类型不需要配送",
            type: "warning"
          });
          return false;
        } else {
          if (e.distrType != "10") {
            this.$message({
              message: "不是待装车状态，不可再配送",
              type: "warning"
            });
            return false;
          }
          return true;
        }
      });
      if (res == false) {
        return false;
      }
      this.$confirm("是否确认装车?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let pmIds = "";
          this.checkListMain.forEach(element => {
            pmIds = pmIds + element.spdId + ",";
          }),
            this.$http
              .request({
                url: "/api/pick/insertStockProductShipWc",
                method: "POST",
                showLoading: true,
                params: {
                  spdIds: pmIds.slice(0, pmIds.length - 1),
                  fcCode: localStorage.getItem("fcCode") || "",
                  whCode: localStorage.getItem("whCode") || "",
                  laCode: null,
                  distrType: "20",
                  person: localStorage.getItem("user") || "",
                  personNumber: localStorage.getItem("empNumber") || null
                }
              })
              .then(resp => {
                if (resp.status == 100) {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  this.logRemarks = "stockProduceMat：生产叫料确认装车成功";
                } else {
                  this.$message({
                    message: resp.message,
                    type: "error"
                  });
                  this.logRemarks = "stockProduceMat：生产叫料确认装车失败";
                }
                this.logContent =
                  "pmIds：" +
                  pmIds +
                  "，personNumber: " +
                  localStorage.getItem("empNumber") +
                  "，person: " +
                  localStorage.getItem("user");
                this.systemLog();
                this.getTableData();
              })
              .catch(error => {
                this.$message({
                  message: "操作失败",
                  type: "error"
                });
              });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    /**
     * 人工配送完成
     */
    personPickComplete() {
      if (this.checkListMain.length == 0) {
        this.$message({
          message: "请选择待装车的记录",
          type: "warning"
        });
        return;
      }

      for (var index in this.checkListMain) {
        if (this.checkListMain[index].operaType == "30") {
          this.$message({
            message: "采购退货类型不需要配送",
            type: "warning"
          });
          return;
        }
        if (this.checkListMain[index].distrWay != "20") {
          this.$message({
            message: "请选择人工配送记录",
            type: "warning"
          });
          return;
        }
        if (this.checkListMain[index].distrType != "20") {
          this.$message({
            message: "请选择配送中的记录",
            type: "warning"
          });
          return;
        }
      }

      this.$confirm("确认放入此位置吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let pmIds = "";
          this.checkListMain.forEach(element => {
            if (pmIds == "") {
              pmIds = element.spdId;
            } else {
              pmIds += "," + element.spdId;
            }
          });
          this.$http
            .request({
              url: "/api/pick/personPickComplete",
              method: "POST",
              showLoading: true,
              params: {
                spdIds: pmIds,
                lrCode: this.lcCode,
                personNumber: localStorage.getItem("empNumber") || null,
                person: localStorage.getItem("user") || ""
              }
            })
            .then(resp => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.logRemarks = "stockProduceMat：生产叫料确认人工配送成功";
              } else {
                this.$message({
                  message: resp.message,
                  type: "error"
                });
                this.logRemarks = "stockProduceMat：生产叫料确认人工配送失败";
              }
              this.logContent =
                "pmIds：" +
                pmIds +
                "lrCode: " +
                this.lcCode +
                "，personNumber: " +
                localStorage.getItem("empNumber") +
                "，person: " +
                localStorage.getItem("user");
              this.systemLog();
              this.lcCode = "";
              this.personDistrShow = false;
              this.getTableData();
            })
            .catch(error => {
              this.$message({
                message: "操作失败",
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    /**
     * 回显AGV配送数据
     */
    openDialog() {
      if (this.checkListMain.length == 0) {
        this.$message({
          message: "请选择叫料",
          type: "warning"
        });
        return;
      }
      let arr = [];

      this.checkListMain.forEach(function(c) {
        arr.push(c.ppCode);
      });
      this.ppCodeList = [...new Set(arr)];
      this.dialogShow = true;
    },
    closeDailog() {
      if (this.ppCode != "") {
        location.reload();
      }
      this.ppCodeList = "";
      this.agvInfo.pmIds = "";

      this.agvInfo.laCode = "";
      this.dialogShow = false;
      this.getTableData();
    },

    /**
     * AVG配送
     */
    agvDistribution() {
      if (this.ppCode == "") {
        this.$message({
          message: "请选择单号",
          type: "warning"
        });
        return;
      }
      let pmIds = "";
      this.checkListMain.forEach(element => {
        pmIds = pmIds + element.spdId + ",";
      }),
        this.$confirm("是否确认合并?", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.agvDistributions = true;
            this.$http
              .request({
                url: "/api/pick/insertStockProductShipWc",
                method: "POST",
                showLoading: true,
                params: {
                  spdIds: pmIds.slice(0, pmIds.length - 1),
                  ppCode: this.ppCode,
                  fcCode: localStorage.getItem("fcCode") || "",
                  whCode: localStorage.getItem("whCode") || "",
                  distrType: "20",
                  person: localStorage.getItem("user") || "",
                  personNumber: localStorage.getItem("empNumber") || null
                }
              })
              .then(resp => {
                if (resp.status == 100) {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  this.ppCode = "";
                  this.logRemarks = "stockProduceMat：合并装车单成功";
                  this.closeDailog();
                } else {
                  this.$message({
                    message: resp.message,
                    type: "error"
                  });
                  this.logRemarks = "stockProduceMat：生产叫料确认AGV配送失败";
                }
                this.agvDistributions = false;
                this.logContent =
                  "pmIds：" + this.agvInfo.pmIds + "laCode：" + this.ppCode;
                this.systemLog();
              })
              .catch(error => {
                this.agvDistributions = false;
                this.$message({
                  message: "操作失败",
                  type: "error"
                });
              });
          })
          .catch(() => {
            this.agvDistributions = false;
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        whCode: this.mainSearch.whCode || null,
        fcCode: this.mainSearch.fcCode || null,
        // person: this.mainSearch.person || null,
        distrType: this.mainSearch.distrType || null,
        distrWay: this.mainSearch.distrWay || null,
        operaCode: this.mainSearch.pmCode || null, // 生产叫料编号
        ppCode: this.mainSearch.ppCode || null, //
        matCode: this.mainSearch.matCode || null, // 物料编号
        boxBarCode: this.mainSearch.boxBarCode || null, //箱号
        beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null, // 开始时间
        endTime: this.mainSearch.date ? this.mainSearch.date[1] : null, // 结束时间
        operaType: "70",
        pageNum: 1,
        pageSize: 999999
      };
      this.$http
        .request({
          url: "/api/stockPickDetail/getStockPickDetailData",
          method: "GET",
          params: paramsObj
        })
        .then(resp => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败"
              });
        });
    },
    doPrint() {
      // 至少一条
      if (!this.checkListMain || !this.checkListMain.length) {
        this.$message.warning("请选择要打印的数据");
        return;
      }
      // 装车单号必须有
      const unPpCode = this.checkListMain.some(i => !i.ppCode);
      if (unPpCode) {
        this.$message.warning("装车单号不能为空");
        return;
      }
      // 装车单号必须相同
      const ppCode = this.checkListMain[0].ppCode;
      const unSamePpCode = this.checkListMain.some(i => i.ppCode !== ppCode);
      if (unSamePpCode) {
        this.$message.warning("请选择相同的装车单号");
        return;
      }
      this.timeDate = this.getTime();
      this.printList = JSON.parse(JSON.stringify(this.checkListMain));
      this.printPPCode = this.printList[0].ppCode;
      this.printShow = true;
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then(excel => {
        list.forEach(function(c) {
          if (c.distrType == "10") {
            c["distrType"] = "待装车";
          } else if (c.distrType == "20") {
            c["distrType"] = "已装车";
          } else if (c.distrType == "30") {
            c["distrType"] = "完成";
          }

          if (c.operaType == "10") {
            c["operaType"] = "生产叫料";
          } else if (c.operaType == "20") {
            c["operaType"] = "间材叫料";
          } else if (c.operaType == "30") {
            c["operaType"] = "采购退货";
          } else if (c.operaType == "40") {
            c["operaType"] = "移库";
          }

          if (c.distrWay == "10") {
            c["distrWay"] = "AGV配送";
          } else if (c.distrWay == "20") {
            c["distrWay"] = "人工配送";
          }
        });
        const tHeader = [
          "装车单号",
          "通道编号",
          "物料编号",
          "物料描述",
          "物料数量",
          "实际库位",
          "包装箱号",
          "操作编号",
          "状态",
          "装车人",
          "托盘类型",
          "装车时间",
          "更新时间"
        ];
        const filterVal = [
          "ppCode",
          "whCode",
          "matCode",
          "matName",
          "matQuan",
          "lcCodeReal",
          "boxBarcode",
          "opCode",
          "distrType",
          "userName",
          "palletCode",
          "createTime",
          "updateTime"
        ];

        const data = this.formatJson(filterVal, list);
        const emptyRow = [];
        const additionalRows = [emptyRow, emptyRow];
        const newContentRow1 = ["外仓司机签字", "", "", "内仓发货人签字"];
        const newContentRow2 = ["日期", "", "", "日期"];
        const updatedData = [
          ...data,
          ...additionalRows,
          newContentRow1,
          [],
          newContentRow2
        ];
        console.log(updatedData);
        // return

        excel.export_json_to_excel({
          header: tHeader,
          data: updatedData,
          filename: "装车记录"
        });
        this.logContent = "导出";
        this.logRemarks = "stock_produce_mat：导出装车记录";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "物料配送",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || ""
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          showLoading: true,
          data: objData
        })
        .then(resp => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch(error => {});
    },
    getLcCodeAllByWhCode(whCode) {
      this.$http
        .request({
          url: "/api/sysLineRouter/getLcCodeAllByWhCode",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || "",
            whCode: whCode || ""
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.sysLineRouterList = resp.data || [];
          }
        })
        .catch(error => {
          this.loading++;
        });
    },
    /**
     * 获取当前时间
     * 格式YYYY-MM-DD
     */
    getTime() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return year + seperator1 + month + seperator1 + strDate;
    }
  },
  activated() {
    // 从页面跳转传值
    let pmCode = this.$route.query.pmCode;
    if (pmCode) {
      this.mainSearch.pmCode = pmCode;
    } else {
      this.getTableData();
    }
    this.getWarehouse();
    /* 获取首页的数据 */
    //this.getLcCodeAllByWhCode();
  }
};
</script>

<style scoped></style>
